import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-right-small",
  "use": "arrow-right-small-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 10\" id=\"arrow-right-small\">\n  <path fill-rule=\"evenodd\" d=\"M259.015,154L253,159.013V148.988Z\" transform=\"translate(-253 -149)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/arrow-right-small.svg
// module id = null
// module chunks = 